import { render, staticRenderFns } from "./bloodCompatibilities.vue?vue&type=template&id=523caddc&scoped=true"
import script from "./bloodCompatibilities.vue?vue&type=script&lang=js"
export * from "./bloodCompatibilities.vue?vue&type=script&lang=js"
import style0 from "./bloodCompatibilities.vue?vue&type=style&index=0&id=523caddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523caddc",
  null
  
)

export default component.exports